export const profile = {
  imgSrc: "/me.jpeg",
  imgAlt: "Maya Saringan",
  title: "Software Engineer @ ",
  bio: [
    `I love my job! No, I mean it. Been proudly a Developer/Engineer/Programmer for what it's been... 6+ years! I love coding but I love the people I've worked with more.\n`,
    `\n\nNow I'm working on Platform Solutions (Build & Test Infastructure) for TV playback for the best streaming service :3`,
  ],
  tags: "Previously @ Salesforce/Tableau; Warner Bros Discovery/You.i TV",
};
